import DOMPurify from "dompurify";
import { marked } from "marked";
import { useMemo } from "react";

// Wiki pages are markdown written by project owners: rendered with marked, then sanitised with
// DOMPurify (no scripts, iframes, styles or event handlers). Links open in a new tab.

let hooked = false;
function purify(html: string): string {
  if (!hooked) {
    DOMPurify.addHook("afterSanitizeAttributes", (node) => {
      if (node.tagName === "A" && node.getAttribute("href")) {
        node.setAttribute("target", "_blank");
        node.setAttribute("rel", "noopener noreferrer");
      }
    });
    hooked = true;
  }
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true }, FORBID_TAGS: ["style", "form", "input", "button", "textarea", "select"], FORBID_ATTR: ["style"] });
}

export function Markdown({ text, language }: { text: string; language: "ar" | "en" }) {
  const html = useMemo(() => purify(marked.parse(text, { async: false, gfm: true, breaks: false })), [text]);
  if (!text.trim()) return <p className="muted">This page is empty.</p>;
  return <div className="prose" dir={language === "ar" ? "rtl" : "ltr"} lang={language} dangerouslySetInnerHTML={{ __html: html }} />;
}
